import { Spacing } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import { Label } from 'design-system/components/Text';
import { TransitionDuration } from 'design-system/variables/transitions';

const FormControlLabel = styled(Label).attrs(() => ({ size: 'md', weight: 'bold' }))<{
  isDisabled?: boolean;
}>`
  margin-bottom: ${Spacing[2]};
  transition: ${TransitionDuration.Fast};
  display: inline-block;

  ${({ theme, isDisabled }) => css`
    color: ${isDisabled ? theme.color.text.disabled : theme.color.text.primary};
  `}
`;

export default FormControlLabel;
